export default __webpack_public_path__ + "static/media/loader.a2746380.gif";